// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3x-2";
export var blackBorderOnHover = "_3x-7";
export var cell = "_3x-6";
export var cellContainer = "_3x-3";
export var checked = "_3x-8";
export var disabled = "_3x-5";
export var featuredIconCellContainer = "_3x-9";
export var featuredIconTextContainer = "_3x-b";
export var featuredIconWrapper = "_3x-a";
export var noBorder = "_3x-c";
export var orangeSelectedRow = "_c7-3";
export var overflowableText = "_3x-0";
export var overflowableTextContainer = "_3x-1";
export var row = "_3z-0";
export var rowCheckboxCell = "_3x-4";
export var selectableTable = "_c7-2";